import { ConvexReactClient } from 'convex/react';
import { API_BASE_URL } from '../utils/constants';

const convexUrl =
  (process.env.REACT_APP_CONVEX_URL && String(process.env.REACT_APP_CONVEX_URL).trim()) ||
  (API_BASE_URL ? `${API_BASE_URL}/convex` : '');

if (!convexUrl) {
  console.error(
    '[Convex] REACT_APP_CONVEX_URL (or REACT_APP_API_URL) is not set. Vendor live tracking will not work.',
  );
} else if (
  process.env.NODE_ENV === 'development' &&
  /localhost:8000\/convex|127\.0\.0\.1:8000\/convex/i.test(convexUrl)
) {
  console.warn(
    `[Convex] URL is ${convexUrl}. FastAPI does not serve Convex — set REACT_APP_CONVEX_URL=http://127.0.0.1:3210 for local tracking.`,
  );
}

export const convexClient = new ConvexReactClient(convexUrl || 'http://127.0.0.1:3210');
